import ProductIcon from '@material-ui/icons/Store';
import ProductCreate from './ProductCreate';
import ProductEdit from './ProductEdit';
import ProductList from './ProductList';
import ProductShow from './ProductShow';

export default {
    list: ProductList,
    create: ProductCreate,
    edit: ProductEdit,
    show: ProductShow,
    icon: ProductIcon,
};
